/* @flow */
import type { Action } from "../action";
import flags from "../../FeatureFlags";

type State = {
  connectionState: number,
  untilNextReconnect: number,
  failedReconnects: number
};

const inittialState = {
  connectionState: WebSocket.CONNECTING,
  failedReconnects: 0,
  untilNextReconnect: 0
};

function connect(state) {
  flags.logSocket && console.log("sock: connecting");
  return {
    ...state,
    connectionState: WebSocket.CONNECTING
  };
}

function reconnectTick(state) {
  if (state.connectionState !== WebSocket.CLOSED) {
    return state;
  }

  if (state.untilNextReconnect > 0) {
    flags.logSocket && console.log(`sock: reconnect in ${state.untilNextReconnect - 1}`);
    return {
      ...state,
      untilNextReconnect: state.untilNextReconnect - 1
    };
  } else {
    return connect(state);
  }
}

function onConnectSuccess(state) {
  flags.logSocket && console.log("sock: connected");
  return {
    connectionState: WebSocket.OPEN,
    failedReconnects: 0,
    untilNextReconnect: 0
  };
}

function onConnectFailure(state) {
  flags.logSocket && console.log("sock: failed");
  return {
    connectionState: WebSocket.CLOSED,
    failedReconnects: state.failedReconnects + 1,
    untilNextReconnect: Math.pow(2, state.failedReconnects + 1)
  };
}

function onSocketStateChange(state, connectionState) {
  switch (connectionState) {
    case WebSocket.OPEN:
      return onConnectSuccess(state);
    case WebSocket.CLOSED:
      return onConnectFailure(state);
    default:
      return { ...state, connectionState };
  }
}

function socket(state?: State = inittialState, action: Action): State {
  switch (action.type) {
    case "SOCKET_CONNECT":
      return connect(state);
    case "SOCKET_RECONNECT_TICK":
      return reconnectTick(state);
    case "SOCKET_CONNECT_SUCCESS":
      return onConnectSuccess(state);
    case "SOCKET_CONNECT_FAILURE":
      return onConnectFailure(state);
    case "SOCKET_STATE_CHANGE":
      return onSocketStateChange(state, action.payload);
    default:
      return state;
  }
}

export default socket;

// Дочерним компонентам не следует знать,
// что мы используем WebSocket для связи
// с сервером. Поэтому мы расшифровываем
// сокетные статусы в обычные строчки.
type ConnectionState = "CONNECTING" | "OPEN" | "CLOSING" | "CLOSED";

export function decryptConnectionState(readyState: number): ConnectionState {
  switch (readyState) {
    case WebSocket.CONNECTING:
      return "CONNECTING";
    case WebSocket.OPEN:
      return "OPEN";
    case WebSocket.CLOSING:
      return "CLOSING";
    case WebSocket.CLOSED:
    default:
      return "CLOSED";
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducer/socket.js